import { useEffect, useState } from 'react';
import { useApi } from './useApi';
import { useAuth } from './useAuth';

export function usePermissions() {
  const { getRoles } = useApi();
  const { user } = useAuth();
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    async function fetchPermissions() {
      console.log('🔍 usePermissions - user:', user);
      console.log('🔍 usePermissions - user.roles:', user?.roles);
      
      if (user && user.roles) {
        const userRoles = user.roles;
        const cacheKey = `permissions_${user.uid}_${userRoles.sort().join('_')}`;
        
        console.log('🔍 usePermissions - userRoles:', userRoles);
        console.log('🔍 usePermissions - cacheKey:', cacheKey);
        
        // Try to get from localStorage
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          console.log('🔍 usePermissions - using cached permissions:', JSON.parse(cached));
          setPermissions(JSON.parse(cached));
        } else {
          try {
            const roles = await getRoles();
            let allPermissions = [];
            
            // Collect permissions from all user roles
            userRoles.forEach(roleId => {
              const role = roles.find(r => r.id === roleId);
              if (role && role.permissions) {
                allPermissions = [...allPermissions, ...role.permissions];
              }
            });
            
            // Remove duplicates
            const uniquePermissions = [...new Set(allPermissions)];
            console.log('🔍 usePermissions - allPermissions:', allPermissions);
            console.log('🔍 usePermissions - uniquePermissions:', uniquePermissions);
            setPermissions(uniquePermissions);
            localStorage.setItem(cacheKey, JSON.stringify(uniquePermissions));
          } catch (err) {
            setPermissions([]);
          }
        }
        // Clean up any old permission caches for this user
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith(`permissions_${user.uid}_`) && key !== cacheKey) {
            localStorage.removeItem(key);
          }
        });
      } else {
        // Clear all cached permissions on logout
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('permissions_')) {
            localStorage.removeItem(key);
          }
        });
        setPermissions([]);
      }
    }
    fetchPermissions();
  }, [user]);

  const can = (permission) => permissions.includes(permission);

  return { permissions, can };
} 